var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 -4 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.80288754 6.34043826 15.4186507 14.72648904 17.58203125 25.4921875 C18.92007691 37.90936834 17.85729499 48.88109459 10.39453125 59.2421875 C3.58210875 67.3274193 -4.72289951 73.55522767 -15.48876953 74.71533203 C-28.40007937 75.61089799 -39.16843729 74.04490094 -49.3515625 65.46484375 C-57.86959925 57.33325857 -62.42046403 48.68416257 -62.88867188 36.85693359 C-63.04371176 24.34263074 -60.22647828 14.71931927 -51.41796875 5.4921875 C-37.63784493 -7.66275112 -16.31305228 -10.17259803 0 0 Z ",
    fill: "#FEC810",
    transform: "translate(70.41796875,13.5078125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8.02886537 4.31248609 8.04675255 8.62494762 8.0625 12.9375 C8.07087891 14.16919922 8.07925781 15.40089844 8.08789062 16.66992188 C8.09111328 17.83974609 8.09433594 19.00957031 8.09765625 20.21484375 C8.10289307 21.29886475 8.10812988 22.38288574 8.11352539 23.49975586 C8 26 8 26 7 27 C4 27.125 4 27.125 1 27 C0 26 0 26 -0.11352539 23.49975586 C-0.10828857 22.41573486 -0.10305176 21.33171387 -0.09765625 20.21484375 C-0.09443359 19.04501953 -0.09121094 17.87519531 -0.08789062 16.66992188 C-0.07951172 15.43822266 -0.07113281 14.20652344 -0.0625 12.9375 C-0.05798828 11.70193359 -0.05347656 10.46636719 -0.04882812 9.19335938 C-0.03699608 6.12885883 -0.02051173 3.06445279 0 0 Z ",
    fill: "#41403B",
    transform: "translate(44,28)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C6.72 0.72 6.72 0.72 8 2 C8.1875 4.4375 8.1875 4.4375 8 7 C6 9 6 9 3 9.3125 C2.01 9.209375 1.02 9.10625 0 9 C-2 6 -2 6 -1.6875 3.375 C-1 1 -1 1 0 0 Z ",
    fill: "#393529",
    transform: "translate(45,59)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9a489686435f30ba12801829b7b10eb8.svg";
export { ForwardRef as ReactComponent };